export const designShowcaseQuery = `
fragment DesignShowcaseRGBAColor on DesignShowcaseRGBAColor {
  hexString
  floatArray
}

fragment DesignShowcaseOrganizationBucket on DesignShowcaseOrganizationBucket {
  bucketId
  bucketGroupId
  displayString
  displayRGBAColor {
    ...DesignShowcaseRGBAColor
  }
}

fragment DesignShowCaseOrganizationBucketGroup on DesignShowCaseOrganizationBucketGroup {
  bucketGroupId
  displayString
  buckets {
    ...DesignShowcaseOrganizationBucket
  }
}

fragment EventPalette on EventPalette {
  paletteId
  paletteName
  accentColor {
    ...DesignShowcaseRGBAColor
  }
  baseText {
    ...DesignShowcaseRGBAColor
  }
  baseColor {
    ...DesignShowcaseRGBAColor
  }
  accentColor {
    ...DesignShowcaseRGBAColor
  }
  accentText {
    ...DesignShowcaseRGBAColor
  }
  accentLightText
  baseLightText
}

fragment DesignShowcaseExhibitSpecification on DesignShowcaseExhibitSpecification {
  owner
  fiancee
  message
  style {
    id
    name
    # supportsColors
    supportsPrints
    supportsEcards
  }
  fontName
  primaryPhotoHorizontal {
    assetId
    width
    height
  }
  palette {
    ...EventPalette
  }
  usesWeddingColor
  websiteLayout {
    template
  }
}

query DesignShowcase {
  designShowcase {
    organization {
      colors {
        ...DesignShowCaseOrganizationBucketGroup
      }
      themes {
        ...DesignShowCaseOrganizationBucketGroup
      }
    }
    exhibits {
      exhibitId
      aspectRatio
      thumbnail(maxWidth: 800, maxHeight: 800) {
        url
      }
      spec {
        ...DesignShowcaseExhibitSpecification
      }
      organizationBuckets {
        ...DesignShowcaseOrganizationBucket
      }
    }
  }
}
`;

// export type DesignShowcaseRGBAColor = {
//   hexString: string;
// };

// export type DesignShowcaseOrganizationBucket = {
//   bucketId: string;
//   bucketGroupId: string;
//   displayString: string;
//   displayRGBAColor: DesignShowcaseRGBAColor | null;
// };

// export type DesignShowCaseOrganizationBucketGroup = {
//   bucketGroupId: string;
//   displayString: string;
//   buckets: DesignShowcaseOrganizationBucket[];
// };

// export type DesignShowcaseExhibitThumbnail = {
//   url: string;
// };

// export type DesignShowcaseExhibit = {
//   exhibitId: string;
//   aspectRatio: number;
//   thumbnail: DesignShowcaseExhibitThumbnail;
//   organizationBuckets: DesignShowcaseOrganizationBucket[];
// };

// export type DesignShowcaseFragment = {
//   designShowcase: {
//     organization: {
//       colors: DesignShowCaseOrganizationBucketGroup;
//       themes: DesignShowCaseOrganizationBucketGroup;
//     };
//     exhibits: DesignShowcaseExhibit[];
//   };
// };

export const designDemoQuery = `
fragment DesignDemoSpecificationStyle on DesignShowcaseExhibitSpecificationStyle {
  id
  name
  supportsWeddingColors
  supportsWebsiteLayoutAloha
  supportsWebsiteLayoutBrannan
  organizationBuckets {
    bucketId
    bucketGroupId
    displayString
  }
  thumbnail(maxWidth: 300, maxHeight: 300, pixelRatio: 2) {
    url
  }
}

fragment DesignShowcaseRGBAColor on DesignShowcaseRGBAColor {
  hexString
  floatArray
}

fragment DesignShowcaseOrganizationBucket on DesignShowcaseOrganizationBucket {
  bucketId
  bucketGroupId
  displayString
  displayRGBAColor {
    ...DesignShowcaseRGBAColor
  }
}

fragment DesignShowCaseOrganizationBucketGroup on DesignShowCaseOrganizationBucketGroup {
  bucketGroupId
  displayString
  buckets {
    ...DesignShowcaseOrganizationBucket
  }
}

query DesignDemo {
  designShowcase {
    organization {
      allStyles {
        ...DesignDemoSpecificationStyle
      }
      colors {
        ...DesignShowCaseOrganizationBucketGroup
      }
    }
  }
}
`;

export const createWeddingQuery = `
fragment DesignShowcaseRGBAColor on DesignShowcaseRGBAColor {
  hexString
  floatArray
}

fragment DesignShowcaseOrganizationBucket on DesignShowcaseOrganizationBucket {
  bucketId
  bucketGroupId
  displayString
  displayRGBAColor {
    ...DesignShowcaseRGBAColor
  }
}


fragment DesignShowCaseOrganizationBucketGroup on DesignShowCaseOrganizationBucketGroup {
  bucketGroupId
  displayString
  buckets {
    ...DesignShowcaseOrganizationBucket
  }
}

query CreateWedding {
  designShowcase {
    organization {
      themes {
        ...DesignShowCaseOrganizationBucketGroup
      }
    }
  }
}
`;
